import { render, staticRenderFns } from "./AdvantagesCompany.vue?vue&type=template&id=7157c30e&scoped=true&lang=pug&"
import script from "./AdvantagesCompany.vue?vue&type=script&lang=js&"
export * from "./AdvantagesCompany.vue?vue&type=script&lang=js&"
import style0 from "./AdvantagesCompany.vue?vue&type=style&index=0&id=7157c30e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7157c30e",
  null
  
)

export default component.exports